import {
  CreatePayrollSummaryDocument,
  CreatePayrollSummaryMutation,
  type CreatePayrollSummaryMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type CreatePayrollSummaryImportResult =
  CreatePayrollSummaryMutation['payrollMutations']['createPayrollPayrollSummaryImport']['payrollSummaryImport']

const useCreatePayrollSummaryImport = () => {
  const [payrollSummaryImport, { loading }] = useMutation(CreatePayrollSummaryDocument, {
    extractorFn: (data) => ({
      ...data.payrollMutations.createPayrollPayrollSummaryImport,
      errors: [],
    }),
  })

  return {
    loading,
    createPayrollSummaryImport(variables: CreatePayrollSummaryMutationVariables) {
      return payrollSummaryImport({
        variables,
      })
    },
  }
}

export default useCreatePayrollSummaryImport
